import React from 'react';
import {View} from 'react-native';

import Text from '../../../components/themed/Text';
import {checkPasswordRequirements} from '../utils/passwordValidation';

/**
 * Component for displaying password requirements with real-time validation status
 */
interface PasswordRequirementsIndicatorProps {
  password: string | undefined;
  show: boolean;
}

export function PasswordRequirementsIndicator({
  password,
  show,
}: PasswordRequirementsIndicatorProps) {
  if (!show) return null;

  const requirements = checkPasswordRequirements(password);
  const allRequirementsMet = requirements.every(req => req.isMet);

  // If all requirements are met, don't show anything (consistent with other fields)
  if (allRequirementsMet) {
    return null;
  }

  // Show individual requirements with their status
  return (
    <View>
      {requirements.map((req, index) => (
        <View
          key={index}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 4,
          }}>
          <Text
            style={{
              fontSize: 16,
              marginRight: 8,
              color: req.isMet ? '#22c55e' : '#ef4444',
              fontWeight: '500',
            }}>
            {req.isMet ? '✓' : '✗'}
          </Text>
          <Text
            style={{
              fontSize: 13,
              color: req.isMet ? '#22c55e' : '#6F6F6F',
            }}>
            {req.label}
          </Text>
        </View>
      ))}
    </View>
  );
}
